
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/kvkk",
      function () {
        return require("private-next-pages/compliance/kvkk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/kvkk"])
      });
    }
  